import type { CSSProperties } from "react";

export type ActivityDensity = "compact" | "default";

/**
 * Every row of the activity grid shares one column template, set once as `--da-cols` on the grid
 * (or on a story/test wrapper) so the header, ticket rows, and span rows stay aligned.
 */
export const activityGridStyle = (showRevenue: boolean, density: ActivityDensity = "default"): CSSProperties => ({
  "--da-cols": [
    "32px", "28px", "28px", "132px",
    "152px", "minmax(170px,1fr)", "84px",
    "152px", "minmax(170px,1fr)", "84px",
    "152px", "76px", ...(showRevenue ? ["92px"] : []), "128px",
  ].join(" "),
  "--da-pad": density === "compact" ? "2px" : "6px",
} as CSSProperties);

export const ACTIVITY_GRID_MIN_WIDTH_CLASS = "min-w-[1490px]";
/**
 * Drivers are cards and shifts are blocks inside them; this is how far a row's left edge sits in from
 * the grid's (card margin 12 + border 1 + block padding 8 + block border 1), so the column header lines up.
 */
export const ACTIVITY_ROW_INSET_CLASS = "mx-[22px]";
export const activityRowClass = "grid grid-cols-[var(--da-cols)] items-stretch";
export const activityCellClass = "flex min-w-0 flex-col justify-center px-2 py-[var(--da-pad,6px)]";
/** Left rule that opens the Pickup, Delivery, and Details column groups. */
export const activityGroupStartClass = "border-l border-[var(--ots-outline-variant)]";
export const activityMutedClass = "text-[var(--ots-text-muted)]";
